import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useModuleAuth from '../hooks/useModuleAuth';
import { safeNavigate } from '../utils/safeNavigate';
import LandingHeader from '../components/landingSnapshot/LandingHeader.jsx';
import PublicSiteFooter from '../../components/Footer/PublicSiteFooter.jsx';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useModuleAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await login(email, password);
      safeNavigate(navigate, '/customers');
    } catch (err) {
      setError(err?.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <LandingHeader />
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
        <div className="space-y-1">
          <p className="text-xs uppercase tracking-wide text-emerald-700">Homevilas</p>
          <h1 className="text-2xl font-bold text-slate-900">Customer Module Login</h1>
          <p className="text-sm text-slate-600">Sign in with your admin or staff credentials.</p>
        </div>

        {error && (
          <div className="mt-4 rounded-lg border border-rose-100 bg-rose-50 px-3 py-2 text-sm text-rose-700">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="mt-5 space-y-4">
          <label className="block text-sm font-medium text-slate-700">
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none"
              placeholder="Email"
              required
            />
          </label>
          <label className="block text-sm font-medium text-slate-700">
            Password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none"
              placeholder="Your password"
              required
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-70"
          >
            {submitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
      </div>
      <PublicSiteFooter />
    </>
  );
};

export default Login;
